/**
 * Rendered markdown, for every piece of AI-written text in v2.
 *
 * Everything the model writes back - the overview summary, the balance
 * diagnosis, the forecast methodology - comes back as markdown: headings,
 * lists, tables. Each of those was printing its own source under a
 * `whitespace-pre-wrap`, so readers saw hashes, asterisks and pipe tables.
 *
 * One component rather than three copies of the same prose classes, so the
 * next piece of AI text does not become a fourth. v2-owned: v1 renders its
 * own markdown its own way and is not touched by changes here.
 *
 * The ink is themed in styles/globals.css. @tailwindcss/typography bakes its
 * palette at build time, so `prose` does NOT follow the ramp on its own and
 * would render dark text on the dark and sepia surfaces.
 */

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function Markdown({ children }: { children: string }) {
  return (
    <div className="prose prose-sm max-w-none text-gray-700 prose-headings:my-2 prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-li:my-0.5 prose-table:my-2">
      {/* remark-gfm is what makes tables, strikethrough and task lists work;
          without it a pipe table renders as a paragraph of pipes. */}
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>
    </div>
  );
}
